// extracted by mini-css-extract-plugin
export default {"ImageWrapper":"OfferImage_ImageWrapper__WW1b3"};